export const isAdminRole = (u) => !!u && (u.role === "admin" || u.role === "sub_admin");
export const isSuperAdmin = (u) => !!u && u.role === "admin";
export const isSubAdmin = (u) => !!u && u.role === "sub_admin";
